export default __webpack_public_path__ + "static/banner_mobile-6792bcb4b60128ed3252690a33f01899.png";